import { connect } from "react-redux";
import {
    KeywordGeneratorToolPageTableBase,
    mapDispatchToPropsBase,
    mapStateToPropsBase,
} from "./KeywordGeneratorToolPageBase";
import { RelatedTableSettings } from "./RelatedTableSettings";
import CountryService from "app/services/CountryService";
import { shortMonthAndYear } from "@similarweb/pro-logic-components";
import DurationService from "app/services/DurationService";
import { capitalizeIntent } from "app/pages/keyword-research/keyword-analysis/pages/keyword-generator/google-keyword-generator/utils";
import { getVolumeValue } from "app/pages/website-analysis/traffic-sources/search/common/utils";
import { TABLE_TYPES_FOR_ENDPOINT } from "app/common/keyword-research/keyword-generator/constants";
import type { IRelatedKeywordsApiResponse } from "app/common/keyword-research/keyword-generator/types";

class KeywordGeneratorToolPageRelatedTable extends KeywordGeneratorToolPageTableBase {
    protected tableSettings = RelatedTableSettings;
    protected tableStorageKey = "KeywordGeneratorToolRelatedTable";
    protected dropdownAppendTo = ".secondTab .swReactTable-header-wrapper";
    protected pageIndent = 1;

    protected dataParamsAdapter = (params) => {
        return {
            ...params,
            type: TABLE_TYPES_FOR_ENDPOINT.related,
        };
    };

    protected transformData = (data: IRelatedKeywordsApiResponse) => {
        const maxScore = data.maxScore;
        return {
            ...data,
            records: data.records.map((keywordGroupDetail) => {
                const countryName = CountryService.getCountryById(this.props.country).text;
                const durationText = DurationService.getFormattedDateOutOfDurationParam(
                    this.props.duration,
                    shortMonthAndYear,
                );
                return {
                    ...keywordGroupDetail,
                    averageVolume: getVolumeValue(keywordGroupDetail.averageVolume),
                    monthlyVolume: getVolumeValue(keywordGroupDetail.monthlyVolume),
                    windowVolume: getVolumeValue(keywordGroupDetail.windowVolume),
                    SearchTerm: keywordGroupDetail.keyword,
                    url: this.getUrlForKeyWord(keywordGroupDetail.keyword),
                    country: this.props.country,
                    countryName,
                    durationText,
                    web_source: this.props.webSource,
                    score: Math.sqrt(Math.min(1, keywordGroupDetail.score / maxScore)) * 5,
                    intents: {
                        PrimaryIntent: capitalizeIntent(keywordGroupDetail.primaryIntent),
                        SecondaryIntent: capitalizeIntent(keywordGroupDetail.secondaryIntent),
                    },
                    VolumeChange: {
                        first: keywordGroupDetail?.volume,
                        last: keywordGroupDetail?.prevVolume,
                        change: keywordGroupDetail?.volumeChange,
                        changeState: keywordGroupDetail?.volumeChangeState,
                    },
                };
            }),
        };
    };
}

export default connect(
    mapStateToPropsBase,
    mapDispatchToPropsBase,
)(KeywordGeneratorToolPageRelatedTable as React.ComponentType<any>);
